/* Current Nostalgia - filter helpers.

   1. Search inside long filters. A facet with a lot of values (Brand has 34) is a scroll, not a
      choice. Any list past a dozen entries gets a search box above it that narrows the list as
      you type.

   2. Sort as a button + dropdown (v58), limited to Featured / relevance, price and A-Z (v64). Filters are a row of buttons that each open a dropdown;
      the native sort <select> didn't match them and read as a form field. It is replaced on
      screen by a "Sort: Featured" button with the same dropdown treatment. The real <select>
      stays in the form (hidden), so Dawn's filtering keeps working unchanged: picking an option
      sets the select's value and fires the same input event Dawn already listens for.

   Dawn re-renders the facets block (including the sort box) after each filter change, so both
   enhancements re-apply themselves whenever the markup is replaced; enhancing twice is a no-op.

   v1.9: the re-apply pass is sturdier. It used to wait until the page had been quiet for 80ms, so
   a page that kept changing could put it off; now it runs within 60ms of the first change, the
   observer is held on to, and for five seconds after any sort or filter change the page is
   re-checked every quarter second. (The iPhone report behind this turned out to be the category
   links in the Current Nostalgia film header disappearing once one was picked - see
   snippets/cn-collection-intro, v1.10 - not this Sort button.)
   Also written without backslash escapes (whitespace and the "(12 products)" counts are matched
   with character classes built below), so the file can be uploaded through the Admin API. */
(function () {
  if (window.__cnFacets) return;
  window.__cnFacets = true;

  var MIN = 12;
  var WS = '[ ' + String.fromCharCode(9, 10, 11, 12, 13, 160) + ']';
  var RE_WS = new RegExp(WS + '+', 'g');
  var RE_COUNT = new RegExp('[(]' + WS + '*[0-9][0-9,]*' + WS + '*products?' + WS + '*[)]', 'gi');
  /* v1.9: accents are ignored, so "stussy" finds Stüssy and "aime" finds Aimé Leon Dore */
  var RE_MARKS = new RegExp('[' + String.fromCharCode(0x300) + '-' + String.fromCharCode(0x36f) + ']', 'g');
  function plain(t) {
    return (t.normalize ? t.normalize('NFD') : t).replace(RE_MARKS, '').toLowerCase();
  }

  function label(li) {
    return plain((li.textContent || '')
      .replace(RE_COUNT, '')
      .replace(RE_WS, ' ')
      .trim());
  }

  function enhance(details) {
    /* v1.9: checks for the box itself - Dawn refills the <details> after each sort or filter but
       keeps its attributes, so checking a flag on it left the brand search off after a sort */
    if (!details || details.querySelector('.cn-facet-search')) return;
    var list = details.querySelector('ul');
    if (!list) return;
    var items = Array.prototype.slice.call(list.querySelectorAll(':scope > li'));
    if (items.length < MIN) return;
    details.setAttribute('data-cn-search', '1');

    var sum = details.querySelector('summary');
    var name = sum ? sum.textContent.replace(RE_WS, ' ').split('(')[0].trim() : 'options';
    name = name.toLowerCase();

    var box = document.createElement('div');
    box.className = 'cn-facet-search';
    var input = document.createElement('input');
    input.type = 'search';
    input.className = 'cn-facet-search__input';
    input.placeholder = 'Search ' + name;
    input.setAttribute('aria-label', 'Search ' + name);
    box.appendChild(input);

    var none = document.createElement('p');
    none.className = 'cn-facet-search__none';
    none.hidden = true;
    none.textContent = 'No matches';

    list.parentNode.insertBefore(box, list);
    list.parentNode.insertBefore(none, list.nextSibling);

    input.addEventListener('input', function () {
      var q = plain(input.value.trim());
      var shown = 0;
      items.forEach(function (li) {
        var ok = !q || label(li).indexOf(q) > -1;
        li.hidden = !ok;
        if (ok) shown++;
      });
      none.hidden = shown > 0;
    });

    /* The box sits inside a <details> and, on mobile, inside a drawer that closes on Escape -
       neither should react to someone typing a brand name. It also sits inside Dawn's filter
       form, which re-submits on every 'input' event; typing in the box must not do that. */
    ['keydown', 'keyup', 'click', 'pointerdown', 'input', 'change'].forEach(function (ev) {
      input.addEventListener(ev, function (e) { e.stopPropagation(); });
    });
  }

  var KEEP = ['manual', 'relevance', 'price-ascending', 'price-descending', 'title-ascending', 'title-descending'];

  function trimSort(sel) {
    Array.prototype.slice.call(sel.options).forEach(function (opt) {
      if (KEEP.indexOf(opt.value) === -1 && opt.value !== sel.value) opt.remove();
    });
  }

  var CARET = '<svg class="cn-sort__caret" width="10" height="6" viewBox="0 0 10 6" aria-hidden="true"><path d="M1 1l4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.4"/></svg>';

  function enhanceSort(box) {
    if (!box || box.querySelector(':scope > .cn-sort')) return;
    var sel = box.querySelector('select[name="sort_by"]');
    if (!sel) return;

    /* v64: only the sorts shoppers use here - Featured (or Most relevant on search), price and
       A-Z. Best selling and the date sorts are dropped from the list; if a link arrives with one
       of them already applied it stays selectable so the page still reads correctly. */
    trimSort(sel);

    var d = document.createElement('details');
    d.className = 'cn-sort';
    var s = document.createElement('summary');
    s.className = 'cn-sort__btn';
    s.innerHTML = '<span class="cn-sort__k">Sort:</span> <span class="cn-sort__v"></span>' + CARET;
    var val = s.querySelector('.cn-sort__v');

    var list = document.createElement('ul');
    list.className = 'cn-sort__list';
    list.setAttribute('aria-label', 'Sort by');

    function paint() {
      var opt = sel.options[sel.selectedIndex];
      val.textContent = opt ? opt.textContent.trim() : '';
      list.querySelectorAll('button').forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-value') === sel.value ? 'true' : 'false');
      });
    }

    Array.prototype.forEach.call(sel.options, function (opt) {
      var li = document.createElement('li');
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'cn-sort__opt';
      b.setAttribute('data-value', opt.value);
      b.textContent = opt.textContent.trim();
      b.addEventListener('click', function () {
        d.open = false;
        if (sel.value === opt.value) return;
        sel.value = opt.value;
        paint();
        watch();
        sel.dispatchEvent(new Event('input', { bubbles: true }));
        sel.dispatchEvent(new Event('change', { bubbles: true }));
      });
      li.appendChild(b);
      list.appendChild(li);
    });

    d.appendChild(s);
    d.appendChild(list);
    box.appendChild(d);
    box.classList.add('cn-has-sort');
    paint();

    /* Behave like the filter dropdowns: one open at a time, close on outside click or Escape. */
    d.addEventListener('toggle', function () {
      if (!d.open) return;
      document.querySelectorAll('.facets__form details[open]').forEach(function (o) { if (o !== d) o.open = false; });
      var cur = list.querySelector('[aria-pressed="true"]') || list.querySelector('button');
      if (cur) cur.focus({ preventScroll: true });
    });
    d.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && d.open) { d.open = false; s.focus(); e.stopPropagation(); }
    });
  }

  document.addEventListener('click', function (e) {
    document.querySelectorAll('.cn-sort[open]').forEach(function (d) {
      if (!d.contains(e.target)) d.open = false;
    });
    /* Opening a filter closes the sort dropdown, and vice versa */
    var sum = e.target.closest && e.target.closest('.facets__form details:not(.cn-sort) > summary');
    if (sum) document.querySelectorAll('.cn-sort[open]').forEach(function (d) { d.open = false; });
    /* removing a filter (the pills above the grid) re-renders the facets too */
    if (e.target.closest && e.target.closest('facet-remove, .active-facets a, .mobile-facets__footer a')) watch();
  });

  function scan() {
    document.querySelectorAll('.facets__form details:not(.cn-sort), .mobile-facets__details').forEach(enhance);
    document.querySelectorAll('.facets__form .facet-filters.sorting').forEach(enhanceSort);
    document.querySelectorAll('select[name="sort_by"]').forEach(trimSort);
  }

  /* v1.9: re-apply soon after any change to the page, however busy it is */
  var queued = 0;
  function soon() {
    if (queued) return;
    queued = setTimeout(function () { queued = 0; scan(); }, 60);
  }

  /* v1.9: after a sort or filter change, keep re-checking for five seconds while Dawn swaps in
     the new markup */
  var ticks = 0, timer = 0;
  function watch() {
    ticks = 0;
    if (timer) return;
    timer = setInterval(function () {
      scan();
      if (++ticks >= 20) { clearInterval(timer); timer = 0; }
    }, 250);
  }
  document.addEventListener('change', function (e) {
    var el = e.target;
    if (el && el.closest && el.closest('facet-filters-form, .mobile-facets, .facets-container')) watch();
  }, true);

  scan();
  if (window.MutationObserver) {
    window.__cnFacetsObserver = new MutationObserver(soon);
    window.__cnFacetsObserver.observe(document.body, { childList: true, subtree: true });
  }
  document.addEventListener('cn:grid', scan);
  window.addEventListener('pageshow', scan);
  window.addEventListener('popstate', function () { watch(); });
})();

/* Collection header "Read more" (v68), like Kith: the description shows as one line (two on
   phones) with READ MORE beside it; the full text stays in the page for search engines.
   The button only appears when the text is actually cut off. */
(function () {
  function setup(d) {
    if (d.__cnRm) return;
    d.__cnRm = true;
    var text = document.createElement('div');
    text.className = 'cn-rm__text';
    while (d.firstChild) text.appendChild(d.firstChild);
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'cn-rm__btn';
    btn.setAttribute('aria-expanded', 'false');
    btn.textContent = 'Read more';
    d.appendChild(text);
    d.appendChild(btn);
    d.classList.add('cn-rm');
    btn.addEventListener('click', function () {
      var open = d.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? 'Show less' : 'Read more';
    });
    function check() {
      if (d.classList.contains('is-open')) return;
      d.classList.toggle('is-short', text.scrollHeight <= text.clientHeight + 2);
    }
    check();
    if (window.ResizeObserver) new ResizeObserver(check).observe(text);
    else window.addEventListener('resize', check);
  }
  function run() { document.querySelectorAll('.cn-colhead__desc').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();